import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-error',
    template: `<div class="container padding-top-3x padding-bottom-3x mb-1">
  <h1 class="display-401 text-center">401</h1>
  <div class="text-center">
    <h2>You are not authorized to access this page.
    </h2>
    <p class="text-sm">It seems You are not authorized to access the page you are looking for.
      <a [routerLink]="route">Go back to Sign In</a>
  </div>
</div>`,
    standalone: false
})
export class ErrorComponent implements OnInit {
  route = '/login-stoda';
  constructor() { }

  ngOnInit() {
  }

}
